export const StepperActiveSvg = (props) => (
    <svg width={props.width || "28"} height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="14" cy="14" r="14" fill="white" />
        <circle cx="14" cy="14" r="13.5" stroke={props.circleColor || "#7D8492"} stroke-opacity={props.circleColor ? "1":"0.42"} />
        <path d="M10 14.75L12.1818 17L18 11" stroke={props.circleColor || "#6C6C6C"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)